import styled from '@emotion/styled';
import { AppBar, Box } from '@mui/material';
import {
  mainAppBarDimen,
  mainDrawerDimen,
  toolBarDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameState } from '../MainFrame';

const openMixin = theme => {
  return {
    width: `calc(100% - ${toPixel(mainDrawerDimen.open.width)})`,
    // width: `calc(100% - 140px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  };
};
const NVToolbar = () => {
  const { mainDrawerOpen, isToolbarOpen, toolBarJsx, isRightDrawerOpen } =
    useMainFrameState();

  const NVAppBar = styled(AppBar, {
    shouldForwardProp: props => true,
  })(props => {
    const { theme } = props;
    return {
      zIndex: isRightDrawerOpen
        ? theme.zIndex.drawer + 1
        : theme.zIndex.modal + 1,
      // overflow: "hidden",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: toPixel(toolBarDimen.height),
      width: `calc(100% - ${toPixel(mainDrawerDimen.closed.width)})`,
      backgroundColor: theme.palette.toolBarColor,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      ...(mainDrawerOpen && openMixin(theme)),
      ...(isToolbarOpen && {
        marginTop: toPixel(mainAppBarDimen.height),
      }),
    };
  });
  return (
    <>
      <NVAppBar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            ml: 3,
          }}
        >
          {toolBarJsx}
        </Box>
      </NVAppBar>
    </>
  );
};

export default NVToolbar;
